import { calculateEquipmentTax } from "@dmf/calculator-library"
import { EquipmentTaxInput } from "@dmf/calculator-library/dist/registrationFee/equipment/types"
import { Vehicle } from "../../../../../types/appTypes"

export const shouldCalculateEquipmentTax = (vehicle?: Vehicle | null): vehicle is Vehicle => !!vehicle && vehicle?.emissionAmount === 0 && new Date(vehicle.firstRegDate ?? "").getFullYear() >= 2021;

export function getCalculatedEquipmentTax(vehicle: Vehicle | null | undefined, equipmentPrice: number, withTax: boolean, newPrice: number) {
  try {
    if (!shouldCalculateEquipmentTax(vehicle)) {
      return null
    }
    const equipmentTaxInput: EquipmentTaxInput = {
      equipment: {
        priceIsTaxFree: withTax,
        priceNoTax: equipmentPrice,
        priceWithTax: equipmentPrice,
      },
      vehicle: {
        batteryCapacity: 0,
        electricConsumption: 0,
        electricRange: 0,
        // @ts-expect-error Type 'string' is not assignable to type 'ObjectValues<{ readonly WLTP: "WLTP"; readonly NEDC: "NEDC"; readonly NEDC2: "NEDC2"; }>'
        emissionUnit: vehicle.emissionUnit ?? "WLTP",
        emissionValue: vehicle.emissionAmount ?? 0,
        newPrice: newPrice,
        taxableValue: null,
        versionYear: new Date(vehicle.firstRegDate ?? "").getFullYear() as 2025,
      }
    }
    const res = calculateEquipmentTax(equipmentTaxInput)
    return withTax ? res.equipment.priceWithTax : res.equipment.price
  } catch (error) {
    console.error(error)
    return 0;
  }
}
